/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAddressData } from './CreateAddressData';
import {
    CreateAddressDataFromJSON,
    CreateAddressDataFromJSONTyped,
    CreateAddressDataToJSON,
    CreateAddressDataToJSONTyped,
} from './CreateAddressData';

/**
 * 
 * @export
 * @interface CreateCompanyData
 */
export interface CreateCompanyData {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyData
     */
    companyName: string;
    /**
     * 
     * @type {CreateAddressData}
     * @memberof CreateCompanyData
     */
    address: CreateAddressData;
    /**
     * The locales a company can be set to, which drive both translations and the formatting of dates and numbers.
     * @type {string}
     * @memberof CreateCompanyData
     */
    locale?: CreateCompanyDataLocaleEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyData
     */
    timezone: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyData
     */
    billingPackageId: number;
    /**
     * A series of national/public holidays that apply to this company
     * @type {number}
     * @memberof CreateCompanyData
     */
    holidayRegionId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyData
     */
    terms: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyData
     */
    recaptchaToken: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateCompanyDataLocaleEnum {
    EnGb = 'en-GB',
    EnUs = 'en-US',
    FrFr = 'fr-FR'
}


/**
 * Check if a given object implements the CreateCompanyData interface.
 */
export function instanceOfCreateCompanyData(value: object): value is CreateCompanyData {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('billingPackageId' in value) || value['billingPackageId'] === undefined) return false;
    if (!('terms' in value) || value['terms'] === undefined) return false;
    if (!('recaptchaToken' in value) || value['recaptchaToken'] === undefined) return false;
    return true;
}

export function CreateCompanyDataFromJSON(json: any): CreateCompanyData {
    return CreateCompanyDataFromJSONTyped(json, false);
}

export function CreateCompanyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompanyData {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'address': CreateAddressDataFromJSON(json['address']),
        'locale': json['locale'] == null ? undefined : json['locale'],
        'timezone': json['timezone'],
        'billingPackageId': json['billingPackageId'],
        'holidayRegionId': json['holidayRegionId'] == null ? undefined : json['holidayRegionId'],
        'terms': json['terms'],
        'recaptchaToken': json['recaptchaToken'],
    };
}

  export function CreateCompanyDataToJSON(json: any): CreateCompanyData {
      return CreateCompanyDataToJSONTyped(json, false);
  }

  export function CreateCompanyDataToJSONTyped(value?: CreateCompanyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyName': value['companyName'],
        'address': CreateAddressDataToJSON(value['address']),
        'locale': value['locale'],
        'timezone': value['timezone'],
        'billingPackageId': value['billingPackageId'],
        'holidayRegionId': value['holidayRegionId'],
        'terms': value['terms'],
        'recaptchaToken': value['recaptchaToken'],
    };
}

